var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9718 21.3493C42.3134 20.9828 42.4993 20.498 42.4905 19.9971C42.4816 19.4962 42.2787 19.0182 41.9245 18.664C41.5702 18.3097 41.0923 18.1068 40.5913 18.098C40.0904 18.0891 39.6056 18.2751 39.2391 18.6166L23.848 34.0077L17.4802 27.6398C17.1137 27.2983 16.6289 27.1123 16.128 27.1212C15.627 27.13 15.1491 27.333 14.7948 27.6872C14.4406 28.0415 14.2377 28.5194 14.2288 29.0203C14.22 29.5212 14.4059 30.006 14.7475 30.3726L22.4817 38.1068C22.8442 38.4689 23.3356 38.6723 23.848 38.6723C24.3604 38.6723 24.8519 38.4689 25.2144 38.1068L41.9718 21.3493Z",
    fill: "#94A3EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3587 0C12.697 0 0 12.697 0 28.3587C0 44.0205 12.697 56.7175 28.3587 56.7175C44.0205 56.7175 56.7175 44.0205 56.7175 28.3587C56.7175 12.697 44.0205 0 28.3587 0ZM3.8671 28.3587C3.8671 21.8631 6.44746 15.6336 11.0405 11.0405C15.6336 6.44746 21.8631 3.8671 28.3587 3.8671C34.8543 3.8671 41.0839 6.44746 45.6769 11.0405C50.27 15.6336 52.8504 21.8631 52.8504 28.3587C52.8504 34.8543 50.27 41.0839 45.6769 45.6769C41.0839 50.27 34.8543 52.8504 28.3587 52.8504C21.8631 52.8504 15.6336 50.27 11.0405 45.6769C6.44746 41.0839 3.8671 34.8543 3.8671 28.3587Z",
    fill: "#94A3EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.727e564683a5d0208aecd0b349c393cf.svg";
export { ForwardRef as ReactComponent };